module.exports = __webpack_public_path__ + "static/img/word.8f169d67.svg";